import { put, call, takeLatest } from 'redux-saga/effects'

import { requestAdditionalEmailVerification as requestAdditionalEmailVerificationApi } from 'Service/Api'

import * as EmailVerificationTypes from 'Redux/Types/EmailVerificationTypes'
import * as EmailVerificationActions from 'Redux/Actions/EmailVerificationActions'

function* requestToDisplayNewEmailVerificationForm() {
  try {
    yield put(EmailVerificationActions.showEmailVerificationFormSucceeded())
  } catch (errors) {
    yield put(
      EmailVerificationActions.showEmailVerificationFormFailed(
        'Error displaying resend email validation form.',
      ),
    )
  }
}

function* requestNewEmailVerification({ payload }) {
  const { params, resolver, rejector } = payload
  try {
    yield call(requestAdditionalEmailVerificationApi, params)
    yield put(EmailVerificationActions.sendNewEmailVerificationSucceeded())
    resolver && resolver()
  } catch (errors) {
    yield put(EmailVerificationActions.sendNewEmailVerificationFailed(errors))
    rejector && rejector()
  }
}

export default function* emailverificationSaga() {
  yield takeLatest(
    EmailVerificationTypes.SEND_NEW_EMAIL_VERIFICATION_REQUEST,
    requestNewEmailVerification,
  )
  yield takeLatest(
    EmailVerificationTypes.SHOW_EMAIL_VERIFICATION_FORM_REQUEST,
    requestToDisplayNewEmailVerificationForm,
  )
}
